export default __webpack_public_path__ + "static/media/alchemylogo.9821dc1c.svg";